import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const OfferView = () => {
  const [OfferUser, setOfferUser] = useState({
    special_offer_image: "",
    title: "",
    brand_logo: "",
    discount: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const OfferData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/special_offer_by_id",
          {
            offer_id: id
          }
        );
        setOfferUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    OfferData();
  }, [id]);

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Special Offer View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Special Offer</Link>
                </li>
                <li className="breadcrumb-item active">Special Offer View</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card Offer-view">
            <div className="cross-icon">
              <Link to="/Offer">
              <i className="fa-solid fa-circle-xmark"></i>
              </Link>
            </div>
              <div>
                <img
                  src={`https://cyberathon.com/multivendor/${OfferUser.special_offer_image}`}
                  width={600} height={400}
                />
                <img
                  src={`https://cyberathon.com/multivendor/${OfferUser.brand_logo}`}
                  width={600} height={400}
                />
              </div>
              <strong>Offer Name</strong>
              <p>{OfferUser.title}</p>
              <strong>Discount</strong>
              <p>{OfferUser.discount}</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default OfferView;
